import { FC } from 'react';
import { translate } from '../../i18n';
import { addressInfoBoxStyles } from './styles';

export interface AddressInfoBoxProps {
  address: string;
  testID?: string;
  title?: string;
}

/**
 * AddressInfoBox — Caja para mostrar información de dirección
 *
 * Cambios:
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para título por defecto
 * ✅ Cero Tailwind, cero hardcodes
 */
export const AddressInfoBox: FC<AddressInfoBoxProps> = ({
  address,
  testID = 'address-info-box',
  title = translate('paymentsUI.addressInfo.billingAddress'),
}) => (
  <div
    style={addressInfoBoxStyles.container}
    data-testid={testID}
    role="region"
    aria-label={translate('paymentsUI.addressInfo.billingAddress')}
  >
    {/* Indicator circle */}
    <div style={addressInfoBoxStyles.indicator} data-testid={`${testID}-indicator`}>
      <div style={addressInfoBoxStyles.indicatorDot} />
    </div>

    {/* Text content */}
    <div style={addressInfoBoxStyles.content}>
      <p style={addressInfoBoxStyles.text}>
        {title}{' '}
        <span style={addressInfoBoxStyles.addressBold} data-testid={`${testID}-address`}>
          {address}
        </span>
      </p>
    </div>
  </div>
);
